import { BehaviorSubject, Observable } from 'rxjs';

export class Store<T> {
  public state$: Observable<T>;
  private stateSubject: BehaviorSubject<T>;
  protected saveInStorage = false;
  protected name = null;

  protected constructor(initialState: T, name: string = null) {
    if (name !== null && initialState === null) {
      this.saveInStorage = true;
      this.name = name;
      initialState = this.loadStateFromLocalStorage();
    }
    this.stateSubject = new BehaviorSubject(initialState);
    this.state$ = this.stateSubject.asObservable();
  }

  get state(): T {
    return this.stateSubject.getValue();
  }

  public setState(nextState: T): void {
    this.stateSubject.next(nextState);
    if (this.saveInStorage) {
      this.saveStateToLocalStorage();
    }
  }

  protected saveStateToLocalStorage(): void {
    if (this.name && this.name.length > 0) {
      localStorage.setItem(this.name, JSON.stringify(this.state));
    }
  }

  protected loadStateFromLocalStorage(): T {
    const storedState = localStorage.getItem(this.name);
    if (storedState) {
      return JSON.parse(storedState);
    }
    return null;
  }

  protected clearStateInLocalStorage() {
    localStorage.removeItem(this.name);
  }

  public clear() {
    this.clearStateInLocalStorage();
    this.setState(null);
  }

}
